<template>
  <div class='vertical-field'>

    <div class="field-label">
      Этапы согласовния:
    </div>

    <div class="stages">

      <template v-for='stage in stages'>

        <div :key='stage.id' class='hide-extra-text' :title="`${stage.newStatus.name} ${stage.description ? '(' + stage.description + ')' : ''}`">
          {{ stage.newStatus.name }} {{ stage.description ? `(${stage.description})` : '' }}
        </div>

        <div :key='stage.id'>
          {{ formatStageDate(stage.date) }}
        </div>

        <div :key='stage.id'>
          <div v-if='showStageUser' :title='stageUserData(stage.user)' class='hide-extra-text'>
            {{ stage.user.email || stage.user.phone }}
          </div>
        </div>

      </template>

    </div>

  </div>
</template>

<script>
import moment from 'moment-timezone';
import PermissionsMixin from '../../../mixins/PermissionsMixin';
import PermissionsEnum from '../../../enums/PermissionsEnum';

export default {
  mixins: [PermissionsMixin],

  props: {
    stages: {
      type: Array,
      required: true
    }
  },

  computed: {
    showStageUser() {
      return this.hasPermission(PermissionsEnum.canSeeUsersInLogs)
    }
  },

  methods: {
    formatStageDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm')
    },

    stageUserData(user) {
      if (user.email) {
        if (!user.phone && !user.name && !user.info) return 'Нет данных'

        return `${user.phone ?? ''} ${user.name ?? ''} ${user.info ?? ''}`
      }

      if (user.phone) {
        if (!user.name && !user.info) return 'Нет данных'

        return `${user.name ?? ''} ${user.info}`
      }
    }
  }
}
</script>

<style>
.stages{
  display: grid;
  grid-template-columns: 38% 20% 38%;
  overflow-y: auto;
  gap: 8px;
}
</style>
